import type { Location } from '@models/location';
import type { Lookup } from '@models/lookup';
import type { Role } from '@models/role';
import type { Scope } from '@models/scope';
import type { User } from '@models/user';

export default function calcClaims(
  state: {
    user: User | undefined;
    roles: Lookup<Role> | undefined;
    locations: Lookup<Location> | undefined;
  },
  scope: Scope[],
) {
  const anyScope = scope.includes('any');
  const activeOrgIds = anyScope
    ? new Set()
    : new Set(
        scope
          .flatMap((id) => {
            return [id, ...(state.locations?.get(id)?.orgs ?? [])];
          })
          .concat('global'),
      );

  const activeRoles =
    state.user?.orgRoles
      .filter((role) => anyScope || activeOrgIds.has(role.orgId))
      .map((role) => ({ ...role, ...state.roles?.get(role.roleId) })) ?? [];

  const activeClaims = activeRoles.flatMap((role) => role.claims ?? []);

  return [...new Set<string>(activeClaims)];
}
